export default __webpack_public_path__ + "6c6e01b507a83e6daf9d5ede9b2e1128.png";